export default __webpack_public_path__ + "static/media/back-arrow.26d20b6c.svg";